import * as React from 'react';

// static image
import komp from '../../../../assets/images/Compendium.jpg';
import appstore from '../../../../assets/images/ap.svg';
import googleplay from '../../../../assets/images/gp.svg';

// locales
import { useTranslation } from 'react-i18next';

// styles
import {
  Wrapper,
  Before,
  Outer,
  Inner,
  Image,
  Download,
  CompendiumUls,
  StyledP,
  MainP,
  StyledLi,
  MainPInline,
} from '../styles';

// static data
import { digitalSolutions } from '../data';

export const EducationalSites = () => {
  // locales hook
  const { t } = useTranslation();

  return (
    <Wrapper>
      <MainP>{digitalSolutions.subtitle}</MainP>

      <h2>{digitalSolutions.digitalForDoctors.title}</h2>
      <Outer>
        <Inner>
          <Outer>
            <Image src={komp} alt="Телефон" />

            <CompendiumUls>
              <h3>{digitalSolutions.digitalForDoctors.subtitle}</h3>
              <MainP>{digitalSolutions.digitalForDoctors.p1}</MainP>

              <ul>
                {digitalSolutions.digitalForDoctors.ul.map((item, index) =>
                  index === 1 ? (
                    <StyledLi>
                      {item}
                      <a
                        href="https://cardioprostir.com.ua/applications-and-calculators/calculators"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Детальніше про калькулятори.
                      </a>
                    </StyledLi>
                  ) : (
                    <StyledLi>{item}</StyledLi>
                  ),
                )}
              </ul>
            </CompendiumUls>
          </Outer>

          <MainP>
            Наразі <b>"Компендіум Servier"</b>{' '}
            {digitalSolutions.digitalForDoctors.p2}{' '}
          </MainP>

          <Before>
            {digitalSolutions.digitalForDoctors.p3}
            <a
              href="https://www.youtube.com/watch?v=B_DGfBp1wL0"
              target="_blank"
              rel="noreferrer"
            >
              відео.
            </a>
          </Before>
          <a
            href="https://drive.google.com/file/d/1uiQnoj-PYqsIQSe_ECFqpEK-Q4lNcxHV/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            Інструкція для встановлення додатку
          </a>

          <StyledP>{digitalSolutions.digitalForDoctors.p4}</StyledP>
          <Download>
            <a
              href="https://play.google.com/store/apps/details?id=com.serviercompendium&hl=uk
"
              target="_blank"
              rel="noreferrer"
            >
              <img src={googleplay} alt="Google Play" />
            </a>{' '}
            <a
              href="https://apps.apple.com/ua/app/servier-компендіум/id1491901097
"
              target="_blank"
              rel="noreferrer"
            >
              <img src={appstore} alt="App Store" />
            </a>
          </Download>

          <Before>
            <MainPInline>
              {digitalSolutions.digitalForDoctors.token1a} <b>комп’ютеру</b>,{' '}
              {digitalSolutions.digitalForDoctors.token1b}
            </MainPInline>
            <a
              href="https://servier.compendium.com.ua"
              target="_blank"
              rel="noreferrer"
            >
              посиланням.
            </a>
          </Before>
          <a
            href="https://drive.google.com/file/d/1uiQnoj-PYqsIQSe_ECFqpEK-Q4lNcxHV/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            Інструкція для використання веб-версії
          </a>
          <p>{digitalSolutions.digitalForDoctors.token6}</p>
        </Inner>
      </Outer>
    </Wrapper>
  );
};

export default EducationalSites;
